<template>
	<div class="mend-sign-wrap">
		<span class="del" @click="closeMend(0)">
			<img src="../../assets/img/common/ic_pop_del@2x.png" alt="" />
		</span>
		<div class="mend-sign-inner">
			<p class="title">{{title}}</p>
			<div class="content">
				<textarea v-model="signText" placeholder="输入你的昵称" autofocus @keyup="culFonts"></textarea>
			</div>
			<div class="options">
				<span>{{fontNum}}/20</span>
				<button @click="submitMend">完成</button>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:"mend-nickname",
		props:["uid","title","text"],
		data(){
			return{
				fontNum:this.text.length,
				signText:this.text,
			}
		},
		cerated(){
			
		},
		methods:{
			closeMend(s){
				this.$emit("closeMend",s)
			},
			culFonts(){
				this.fontNum = this.signText.length;
				if(this.fontNum>20){
					this.$toast({message:"超过字数限制了哦~",position: "bottom",duration: 3000});
					this.signText = this.signText.substr(0,20);
		  			this.fontNum = 20;
				}
			},
			submitMend(){
				this.$axios({
					url:"Modify/UpdateUserSig",
					method:"post",
					data:{
						uid:this.uid,
						new_sig:this.signText
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.$toast({message: res.data.msg,position: "bottom",duration: 3000});
						this.closeMend(1);
					}
				}).catch(err=>{
					console.log(err);
					this.$toast({message:"操作失败",position: "bottom",duration: 3000});
				})
			},
		}
	}
</script>

<style scoped>
	.mend-sign-wrap{
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0,0,0,.3);
		z-index: 10;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 0 1rem;
	}
	.mend-sign-wrap .del img{
		width: 2rem;
	}
	.mend-sign-inner{
		width: 100%;
		background: #fff;
		border-radius: 8px;
		padding: 1.5rem 0.5rem;
	}
	.mend-sign-inner .title{
		font-size: 1rem;
		color: #282828;
		font-weight: bold;
		text-align: center;
		line-height: 2rem;
	}
	.mend-sign-inner .content textarea{
		display: block;
		width: 100%;
		height: 6rem;
		resize: none;
		margin: 1rem 0;
		border: 1px solid #f3f3f3;
		border-radius: 5px;
		padding:0.2rem 0.5rem;
		line-height: 1.5rem;
		outline: 0;
	}
	.mend-sign-inner .options{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.mend-sign-inner .options span{
		font-size: 0.8rem;
		color: #7b7b7b;
	}
	.mend-sign-inner .options button{
		background:linear-gradient(45deg,rgba(154,125,247,1) 0%,rgba(191,181,234,1) 100%);
		padding: 0.5rem 1rem;
		border: 0;
		outline: 0;
		border-radius: 2rem;
		color: #fff;
		
	}
</style>


// WEBPACK FOOTER //
// src/components/Mine/MendNickname.vue